import { useCalendar } from '@pidz/stores';
import { rerouteToOverview } from '@web/pages/calendar/utils';
import { computed } from 'vue';
import { START_LOCATION, useRouter } from 'vue-router';

export async function loadEvents(_to, from) {
  const calendarStore = useCalendar();

  if (from === START_LOCATION) {
    const dateRange = computed(() => {
      const startRange = calendarStore.date.startOf('month');
      const offset = startRange.weekday - 1;
      const startDate = startRange.minus({ days: offset });
      return {
        start: startDate,
        end: calendarStore.date.startOf('month').plus({
          days: 31 + offset,
        }),
      };
    });
    await calendarStore.loadEvents(dateRange.value);
  }
}

export function checkIfEventExists(to) {
  const calendarStore = useCalendar();
  const router = useRouter();
  const event = calendarStore.getEventById(Number(to.params.id));
  if (!event) {
    rerouteToOverview(to, router);
    return false;
  }
  return true;
}
